// Приложения флажками: человек отмечает то, что у него есть, и дописывает своё. Без выбора ничего не подставляется.
import { useContext, useState } from "react";
import { plural } from "../lib/text";
import { QuestionClosed } from "./state";

export function Checklist({ options, initial, onDone }: { options: string[]; initial: string[]; onDone: (items: string[]) => void }) {
  const closed = useContext(QuestionClosed);
  const [own, setOwn] = useState<string[]>(() => initial.filter((item) => !options.includes(item)));
  const [checked, setChecked] = useState<Set<string>>(() => new Set(initial));
  const [draft, setDraft] = useState("");
  const all = [...options, ...own];
  const chosen = all.filter((item) => checked.has(item));

  const toggle = (item: string) => setChecked((now) => {
    const next = new Set(now);
    if (next.has(item)) next.delete(item);
    else next.add(item);
    return next;
  });
  const add = () => {
    const item = draft.trim().replace(/\s+/g, " ");
    if (!item) return;
    if (!all.includes(item)) setOwn((now) => [...now, item]);
    setChecked((now) => new Set(now).add(item));
    setDraft("");
  };

  return (
    <div className="checklist">
      <div className="checklist-items" role="group" aria-label="Приложения">
        {all.map((item) => (
          <label key={item} className="checklist-item">
            <input type="checkbox" checked={checked.has(item)} disabled={closed} onChange={() => toggle(item)} />
            <span>{item}</span>
          </label>
        ))}
      </div>
      <div className="checklist-add">
        <input type="text" value={draft} disabled={closed} maxLength={200} aria-label="Своё приложение"
          placeholder="Своё приложение, например: копия претензии" onChange={(event) => setDraft(event.target.value)}
          onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); add(); } }} />
        <button type="button" className="chip chip-quiet" disabled={closed || !draft.trim()} onClick={add}>Добавить</button>
      </div>
      <div className="checklist-actions">
        <button type="button" className="chip chip-primary" disabled={closed || !chosen.length} onClick={() => onDone(chosen)}>
          {chosen.length ? `Готово: ${plural(chosen.length, "приложение", "приложения", "приложений")}` : "Готово"}
        </button>
        <button type="button" className="chip chip-quiet" disabled={closed} onClick={() => onDone([])}>Без приложений</button>
      </div>
    </div>
  );
}
